import React from "react";

function DeleteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 24 21"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M22.087 7.717s-.729 6.735-1.152 9.572c-.201 1.355-1.325 2.149-3.165 2.174-3.503.047-7.009.05-10.51-.005-1.77-.027-2.875-.831-3.073-2.162-.425-2.862-1.15-9.58-1.15-9.58M23.944 4.49H1.179M7.891 8L9.439 18.92M16.69 7.911l-1.24 10.94M19.558 4.489c-1.054 0-1.961-.555-2.168-1.324l-.326-1.216C16.863 1.388 16.18 1 15.404 1H9.72c-.777 0-1.46.388-1.66.949l-.327 1.216c-.207.769-1.114 1.324-2.168 1.324"
      ></path>
    </svg>
  );
}

export default DeleteIcon;
